// /* eslint-disable react/jsx-no-duplicate-props */


// import { useState, useEffect } from "react";
// import SearchComponent from "../../component/SearchComponent";
// import JobPostJobPage from "../../component/JobPostJobPage";
// import Header from "../../component/Header";
// import { useLocation, useNavigate } from "react-router-dom";
// import qs from "query-string";
// import { useFetchData } from "../../hooks/useFtechData";
// import { ALL_JOB } from "../../resources/resource";
// import Loader from "../../component/utilities/Loader";
// import { getFilteredJobs } from "./data";
// import Card from "./Crad";

// function JobPage() {
//   const [allJobs, setAllJobs] = useState([]);
//   const [filteredJobs, setFilteredJobs] = useState([]);
//   const [filterList, setFilterList] = useState([]);
//   const [mainSearchForm, setMainSearchForm] = useState({});
//   const [selectedLga, setSelectedLga] = useState(null);
//   const [selectedCity, setSelectedCity] = useState(null);
//   const [jobCounts, setJobCounts] = useState({ lgas: {}, cities: {} });
//   const location = useLocation();
//   const navigate = useNavigate();

//   const { jobTitle, workType, state, lga, city } = qs.parse(location.search);

//   const { data, loading, errors } = useFetchData(ALL_JOB);

//   // Extract unique Local Governments and Cities for the selected state
//   const localGovernments = data
//     ? [...new Set(data.filter(job => job.state === state).map(job => job.localGovernment))]
//     : [];
//   const cities = data
//     ? [...new Set(data.filter(job => job.state === state).map(job => job.city))]
//     : [];

//   // Compute job counts for LGAs and cities
//   useEffect(() => {
//     if (data && state) {
//       const stateJobs = data.filter((job) => job.state === state);
//       const lgaCounts = stateJobs.reduce((acc, job) => {
//         if (job.localGovernment) {
//           acc[job.localGovernment] = (acc[job.localGovernment] || 0) + 1;
//         }
//         return acc;
//       }, {});
//       const cityCounts = stateJobs.reduce((acc, job) => {
//         if (job.city) {
//           acc[job.city] = (acc[job.city] || 0) + 1;
//         }
//         return acc;
//       }, {});
//       setJobCounts({ lgas: lgaCounts, cities: cityCounts });
//     } else {
//       setJobCounts({ lgas: {}, cities: {} });
//     }
//   }, [data, state]);

//   useEffect(() => {
//     if (data) {
//       setAllJobs(data);
//       const initialFiltered = getFilteredJobs(data, jobTitle, workType, state);
//       setFilteredJobs(initialFiltered);
//     }
//   }, [data, jobTitle, workType, state]);

//   useEffect(() => {
//     if (lga) setSelectedLga(lga);
//     if (city) setSelectedCity(city);
//     applyFilters(allJobs, { jobTitle, workType, state, lga, city });
//   }, [lga, city, allJobs, jobTitle, workType, state]);

//   const applyFilters = (jobs, filters) => {
//     let filteredResults = jobs;

//     if (filters.jobTitle) {
//       filteredResults = filteredResults.filter((job) =>
//         job.jobTitle.toLowerCase().includes(filters.jobTitle.toLowerCase())
//       );
//     }

//     if (filters.workType) {
//       filteredResults = filteredResults.filter(
//         (job) => job.workType.toLowerCase() === filters.workType.toLowerCase()
//       );
//     }

//     if (filters.state) {
//       filteredResults = filteredResults.filter(
//         (job) => job.state.toLowerCase() === filters.state.toLowerCase()
//       );
//     }

//     if (selectedLga) {
//       filteredResults = filteredResults.filter(
//         (job) => job.localGovernment.toLowerCase() === selectedLga.toLowerCase()
//       );
//     }

//     if (selectedCity) {
//       filteredResults = filteredResults.filter(
//         (job) => job.city && job.city.toLowerCase() === selectedCity.toLowerCase()
//       );
//     }

//     setFilteredJobs(filteredResults);
//   };

//   const handleClearFilter = () => {
//     setFilterList([]);
//     setFilteredJobs(allJobs);
//     setSelectedLga(null);
//     setSelectedCity(null);
//     navigate("/jobs");
//   };

//   const addFilterElement = (e) => {
//     const selectedElement = e.target.value;
//     const title = e.target.name;
//     if (title === "workOrder") {
//       if (selectedElement === "latest") {
//         setFilteredJobs(
//           [...filteredJobs].sort(
//             (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
//           )
//         );
//       } else if (selectedElement === "oldest") {
//         setFilteredJobs(
//           [...filteredJobs].sort(
//             (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
//           )
//         );
//       }
//       return;
//     }
//     const updatedFilteredJobs = filteredJobs.filter(
//       (eachJob) =>
//         eachJob[title].toLowerCase() === selectedElement.toLowerCase()
//     );
//     setFilteredJobs(updatedFilteredJobs);
//     setFilterList([...filterList, { title, selectedElement }]);
//   };

//   const handleChange = (e) => {
//     setMainSearchForm({ ...mainSearchForm, [e.target.name]: e.target.value });
//   };

//   const searchByFilter = (e) => {
//     e.preventDefault();
//     applyFilters(allJobs, mainSearchForm);
//     navigate(`/jobs?${qs.stringify(mainSearchForm)}`);
//   };

//   const handleLgaClick = (lga) => {
//     setSelectedLga(lga);
//     setSelectedCity(null);
//     applyFilters(allJobs, { ...mainSearchForm, lga });
//     navigate(`/jobs?${qs.stringify({ ...mainSearchForm, lga })}`);
//   };

//   const handleCityClick = (city) => {
//     setSelectedCity(city);
//     setSelectedLga(null);
//     applyFilters(allJobs, { ...mainSearchForm, city });
//     navigate(`/jobs?${qs.stringify({ ...mainSearchForm, city })}`);
//   };

//   if (loading) return <Loader />;

//   return (
//     <div className="min-h-screen bg-gray-100 pt-16 sm:pt-20">
//       <Header darkMode={true} />
//       <div className="container mx-auto p-4">
//         <SearchComponent
//           handleSearch={searchByFilter}
//           handleChange={handleChange}
//           lgas={state ? localGovernments : []}
//           cities={state ? cities : []}
//           handleLgaClick={handleLgaClick}
//           handleCityClick={handleCityClick}
//           state={state}
//           jobCounts={jobCounts}
//         />
//         <div className="flex flex-col lg:flex-row gap-8 mt-8 px-10">
//           <div className="w-full lg:w-2/3">
//             {loading ? (
//               <Loader />
//             ) : filteredJobs?.length > 0 ? (
//               filteredJobs?.map((eachJob) => (
//                 <JobPostJobPage
//                   key={eachJob._id}
//                   position={eachJob.jobTitle}
                  
//                   companyName={eachJob.employerName}
//                   location={eachJob.state}
//                   salary={eachJob.salary}
//                   jobType={eachJob.workType}
//                   experience={eachJob.experienceLength}
//                   duration={eachJob.vacancyDuration}
       
//                   jobId={eachJob._id}
//                   contactMail={eachJob.contactMail}
//                   status="Apply now"
//                   localGovernment={eachJob.localGovernment}
//                   city={eachJob.city}
//                 />
//               ))
//             ) : (
//               <p className="text-center text-gray-600">
//                 No jobs found matching your criteria.
//               </p>
//             )}
//           </div>
//           <div className="w-full lg:w-1/3">
//             <Card className="p-6 mb-8 bg-white shadow-sm rounded-lg">
//               <h2 className="text-xl font-semibold text-gray-800 mb-4">
//                 Jobs in Nigeria
//               </h2>
//               <div className="flex items-center justify-between p-3 bg-gray-50 rounded-md">
//                 <span className="text-gray-600">Filter Applied</span>
//                 <button
//                   onClick={handleClearFilter}
//                   className="text-sm text-orange-500 hover:underline"
//                 >
//                   Clear all
//                 </button>
//               </div>
//               <span className="block mt-2 font-bold text-orange-500">
//                 {filteredJobs?.length} jobs found
//               </span>
//             </Card>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default JobPage;



import { useState, useEffect } from "react";
import SearchComponent from "../../component/SearchComponent";
import JobPostJobPage from "../../component/JobPostJobPage";
import Header from "../../component/Header";
import { useLocation, useNavigate } from "react-router-dom";
import qs from "query-string";
import { useFetchData } from "../../hooks/useFtechData";
import { ALL_JOB } from "../../resources/resource";
import Loader from "../../component/utilities/Loader";
import { getFilteredJobs } from "./data";
import Card from "./Crad";

function JobPage() {
  const [allJobs, setAllJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [mainSearchForm, setMainSearchForm] = useState({});
  const [selectedLga, setSelectedLga] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [jobCounts, setJobCounts] = useState({ lgas: {}, cities: {} });
  const location = useLocation();
  const navigate = useNavigate();

  const { jobTitle, workType, state, lga, city } = qs.parse(location.search);

  const { data, loading, errors } = useFetchData(ALL_JOB);

  // Extract unique Local Governments and Cities for the selected state
  const localGovernments = data
    ? [...new Set(data.filter(job => job.state === state && job.status === "Online").map(job => job.localGovernment))]
    : [];
  const cities = data
    ? [...new Set(data.filter(job => job.state === state && job.status === "Online").map(job => job.city))]
    : [];

  // Compute job counts for LGAs and cities
  useEffect(() => {
    if (data && state) {
      const stateJobs = data.filter((job) => job.state === state && job.status === "Online");
      const lgaCounts = stateJobs.reduce((acc, job) => {
        if (job.localGovernment) {
          acc[job.localGovernment] = (acc[job.localGovernment] || 0) + 1;
        }
        return acc;
      }, {});
      const cityCounts = stateJobs.reduce((acc, job) => {
        if (job.city) {
          acc[job.city] = (acc[job.city] || 0) + 1;
        }
        return acc;
      }, {});
      setJobCounts({ lgas: lgaCounts, cities: cityCounts });
    } else {
      setJobCounts({ lgas: {}, cities: {} });
    }
  }, [data, state]);

  useEffect(() => {
    if (data) {
      // Filter jobs where status is "Online"
      const onlineJobs = data.filter(job => job.status === "Online");
      setAllJobs(onlineJobs);
      const initialFiltered = getFilteredJobs(onlineJobs, jobTitle, workType, state);
      setFilteredJobs(initialFiltered);
    }
  }, [data, jobTitle, workType, state]);

  useEffect(() => {
    if (lga) setSelectedLga(lga);
    if (city) setSelectedCity(city);
    applyFilters(allJobs, { jobTitle, workType, state, lga, city });
  }, [lga, city, allJobs, jobTitle, workType, state]);

  const applyFilters = (jobs, filters) => {
    let filteredResults = jobs.filter(job => job.status === "Online"); // Ensure only Online jobs are filtered

    if (filters.jobTitle) {
      filteredResults = filteredResults.filter((job) =>
        job.jobTitle.toLowerCase().includes(filters.jobTitle.toLowerCase())
      );
    }

    if (filters.workType) {
      filteredResults = filteredResults.filter(
        (job) => job.workType.toLowerCase() === filters.workType.toLowerCase()
      );
    }

    if (filters.state) {
      filteredResults = filteredResults.filter(
        (job) => job.state.toLowerCase() === filters.state.toLowerCase()
      );
    }

    if (selectedLga) {
      filteredResults = filteredResults.filter(
        (job) => job.localGovernment.toLowerCase() === selectedLga.toLowerCase()
      );
    }

    if (selectedCity) {
      filteredResults = filteredResults.filter(
        (job) => job.city && job.city.toLowerCase() === selectedCity.toLowerCase()
      );
    }

    setFilteredJobs(filteredResults);
  };

  const handleClearFilter = () => {
    setFilterList([]);
    setFilteredJobs(allJobs);
    setSelectedLga(null);
    setSelectedCity(null);
    navigate("/jobs");
  };

  const addFilterElement = (e) => {
    const selectedElement = e.target.value;
    const title = e.target.name;
    if (title === "workOrder") {
      if (selectedElement === "latest") {
        setFilteredJobs(
          [...filteredJobs].sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          )
        );
      } else if (selectedElement === "oldest") {
        setFilteredJobs(
          [...filteredJobs].sort(
            (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
          )
        );
      }
      return;
    }
    const updatedFilteredJobs = filteredJobs.filter(
      (eachJob) =>
        eachJob[title].toLowerCase() === selectedElement.toLowerCase()
    );
    setFilteredJobs(updatedFilteredJobs);
    setFilterList([...filterList, { title, selectedElement }]);
  };

  const handleChange = (e) => {
    setMainSearchForm({ ...mainSearchForm, [e.target.name]: e.target.value });
  };

  const searchByFilter = (e) => {
    e.preventDefault();
    applyFilters(allJobs, mainSearchForm);
    navigate(`/jobs?${qs.stringify(mainSearchForm)}`);
  };

  const handleLgaClick = (lga) => {
    setSelectedLga(lga);
    setSelectedCity(null);
    applyFilters(allJobs, { ...mainSearchForm, lga });
    navigate(`/jobs?${qs.stringify({ ...mainSearchForm, lga })}`);
  };

  const handleCityClick = (city) => {
    setSelectedCity(city);
    setSelectedLga(null);
    applyFilters(allJobs, { ...mainSearchForm, city });
    navigate(`/jobs?${qs.stringify({ ...mainSearchForm, city })}`);
  };

  if (loading) return <Loader />;

  return (
    <div className="min-h-screen bg-gray-100 pt-16 sm:pt-20">
      <Header darkMode={true} />
      <div className="container mx-auto p-4">
        <SearchComponent
          handleSearch={searchByFilter}
          handleChange={handleChange}
          lgas={state ? localGovernments : []}
          cities={state ? cities : []}
          handleLgaClick={handleLgaClick}
          handleCityClick={handleCityClick}
          state={state}
          jobCounts={jobCounts}
        />
        <div className="flex flex-col lg:flex-row gap-8 mt-8 px-10">
          <div className="w-full lg:w-2/3">
            {loading ? (
              <Loader />
            ) : filteredJobs?.length > 0 ? (
              filteredJobs?.map((eachJob) => (
                <JobPostJobPage
                  key={eachJob._id}
                  position={eachJob.jobTitle}
                  companyName={eachJob.employerName}
                  location={eachJob.state}
                  salary={eachJob.salary}
                  jobType={eachJob.workType}
                  experience={eachJob.experienceLength}
                  duration={eachJob.vacancyDuration}
                  jobId={eachJob._id}
                  contactMail={eachJob.contactMail}
                  status="Apply now"
                  localGovernment={eachJob.localGovernment}
                  city={eachJob.city}
                />
              ))
            ) : (
              <p className="text-center text-gray-600">
                No jobs found matching your criteria.
              </p>
            )}
          </div>
          <div className="w-full lg:w-1/3">
            <Card className="p-6 mb-8 bg-white shadow-sm rounded-lg">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                Jobs in Nigeria
              </h2>
              <div className="flex items-center justify-between p-3 bg-gray-50 rounded-md">
                <span className="text-gray-600">Filter Applied</span>
                <button
                  onClick={handleClearFilter}
                  className="text-sm text-green-500 hover:underline"
                >
                  Clear all
                </button>
              </div>
              <span className="block mt-2 font-bold text-green-500">
                {filteredJobs?.length} jobs found
              </span>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JobPage;